import { t } from '../../utils/i18n';
import { selectedLocationId, setSelectedLocationId } from "../../utils/variables";

export class LocationDropdown {
    constructor({
        inputId = 'locationAskAQuestion',
        parentClass = 'askQuestion__container',
        wrapperClass = 'locationsDropdown__wrapper',
        dataForm = 'locationAskAQuestion',
        optionName = 'locations-dropdown__item',
        locations = []
    }) {
        this.inputId = inputId;
        this.parentClass = parentClass;
        this.wrapperClass = wrapperClass;
        this.locations = locations;
        this.dataForm = dataForm;
        this.optionName = optionName;

        this.boundOnDropdownItemClick = this.onDropdownItemClick.bind(this);
        this.init();
    }

    init() {
        if (this.locations.length > 1) {
            this.getDropdownContainer().innerHTML = this.renderDropdown();
        }
        this.populateLocations(this.locations);
        this.attachEventListeners();
    }

    getDropdownContainer() {
        return document.querySelector(`.${this.parentClass} .location__dropdownAskQuestion`);
    }

    renderDropdown() {
        return `
            <div data-form="${this.dataForm}" class="${this.wrapperClass} dropdown form-control">
                <input id="${this.inputId}" autocomplete="off" placeholder="${t('select_location')}">
                <span class="down arrow"><i class="ri-arrow-down-s-line"></i></span>
                <span class="up arrow"><i class="ri-arrow-up-s-line"></i></span>
                <div class="locationsDropdown__select">
                    <ul class="locations__select"></ul>
                </div>
            </div>
        `;
    }

    getDropdownList() {
        return document.querySelector(`.${this.parentClass} .${this.wrapperClass} .locationsDropdown__select ul`);
    }

    populateLocations(locations) {
        const dropdownList = this.getDropdownList();
        if (!dropdownList) return;

        dropdownList.innerHTML = locations.length
            ? locations.map(({ id, name }) => `
                <li class="${this.optionName}" data-location-id="${id}" data-location-name="${name}">
                    ${name}
                </li>`).join('')
            : `<li class="locations-dropdown__empty">${t('no_locations_found')}</li>`;
    }

    attachEventListeners() {
        const locationInput = document.querySelector(`.${this.parentClass} #${this.inputId}`);
        const dropdownWrapper = document.querySelector(`.${this.parentClass} .${this.wrapperClass}`);

        if (!locationInput || !dropdownWrapper) return;

        locationInput.addEventListener('click', () => this.toggleDropdown());
        document.addEventListener('click', (e) => this.handleOutsideClick(e));
        locationInput.addEventListener('input', (e) => this.handleSearch(e));

        this.attachDropdownSelectionListener();
    }

    attachDropdownSelectionListener() {
        const dropdownList = this.getDropdownList();
        if (!dropdownList) return;

        dropdownList.removeEventListener("click", this.boundOnDropdownItemClick);
        dropdownList.addEventListener("click", this.boundOnDropdownItemClick);
    }

    onDropdownItemClick(event) {
        const item = event.target.closest(`.${this.optionName}`);
        if (!item) return;

        const name = item.getAttribute('data-location-name');
        const id = parseInt(item.getAttribute('data-location-id'));

        this.setSelectedLocationId(id);

        const locationInputElement = document.querySelector(`.${this.parentClass} #${this.inputId}`);
        if (locationInputElement) {
            locationInputElement.value = name;
        }

        document.querySelector(`.${this.parentClass} div[data-form="${this.dataForm}"]`)?.classList.remove('invalid');
        document.querySelector(`.${this.parentClass} .${this.wrapperClass}`)?.classList.add('selected');
        this.toggleDropdown(true);
    }

    handleOutsideClick(event) {
        if (event.target.closest(`.${this.wrapperClass}`)) return;
        this.toggleDropdown(true);
        if (!this.getSelectedLocationId()) this.clearSelection();
    }

    handleSearch(event) {
        const searchValue = event.target.value.toLowerCase();
        this.setSelectedLocationId(null);
        const dropdownList = this.getDropdownList();
        if (!dropdownList) return;

        Array.from(dropdownList.children).forEach(item => {
            const name = item.getAttribute('data-location-name').toLowerCase();
            item.style.display = name.includes(searchValue) ? '' : 'none';
        });
    }

    toggleDropdown(forceClose = false) {
        const dropdownWrapper = document.querySelector(`.${this.parentClass} .${this.wrapperClass}`);
        if (!dropdownWrapper) return;

        const shouldClose = forceClose || dropdownWrapper.classList.contains('open');
        dropdownWrapper.classList.toggle('open', !shouldClose);
    }

    clearSelection() {
        this.setSelectedLocationId(null);

        const locationInput = document.querySelector(`.${this.parentClass} #${this.inputId}`);
        const dropdownWrapper = document.querySelector(`.${this.parentClass} .${this.wrapperClass}`);

        if (locationInput) locationInput.value = '';
        dropdownWrapper?.classList.remove('selected');

        this.populateLocations(this.locations);
    }

    setSelectedLocationId(id) {
        setSelectedLocationId(id);
    }

    getSelectedLocationId() {
        return selectedLocationId;
    }
}
